import { accessPathWithDatum, varName } from '../../../util';
import { TUPLE } from '../selection';
import nearest from './nearest';
import { TUPLE_FIELDS } from './project';
var inputBindings = {
  has: function has(selCmpt) {
    return selCmpt.type === 'single' && selCmpt.resolve === 'global' && selCmpt.bind && selCmpt.bind !== 'scales';
  },
  topLevelSignals: function topLevelSignals(model, selCmpt, signals) {
    var name = selCmpt.name;
    var proj = selCmpt.project;
    var bind = selCmpt.bind;
    var datum = nearest.has(selCmpt) ? '(item().isVoronoi ? datum.datum : datum)' : 'datum';
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var p = _step.value;
        var sgname = varName("".concat(name, "_").concat(p.field));
        var hasSignal = signals.filter(function (s) {
          return s.name === sgname;
        });

        if (!hasSignal.length) {
          signals.unshift({
            name: sgname,
            value: '',
            on: [{
              events: selCmpt.events,
              update: "datum && item().mark.marktype !== 'group' ? ".concat(accessPathWithDatum(p.field, datum), " : null")
            }],
            bind: bind[p.field] || bind[p.channel] || bind
          });
        }
      };

      for (var _iterator = proj[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return signals;
  },
  signals: function signals(model, selCmpt, _signals) {
    var name = selCmpt.name;
    var proj = selCmpt.project;

    var signal = _signals.filter(function (s) {
      return s.name === name + TUPLE;
    })[0];

    var fields = name + TUPLE + TUPLE_FIELDS;
    var values = proj.map(function (p) {
      return varName("".concat(name, "_").concat(p.field));
    });
    var valid = values.map(function (v) {
      return "".concat(v, " !== null");
    }).join(' && ');

    if (values.length) {
      signal.update = "".concat(valid, " ? {fields: ").concat(fields, ", values: [").concat(values.join(', '), "]} : null");
    }

    delete signal.value;
    delete signal.on;
    return _signals;
  }
};
export default inputBindings;